import { messageBoxSuccess, messageBoxError } from '../components/message-box';
import FormValidation from '../components/form-validation';

class PopupExpert {
  public popup: HTMLElement | null;

  public form: HTMLFormElement | null;

  public uploadButtons: NodeListOf<HTMLInputElement> | undefined;

  public addUploadButton: HTMLElement | null;

  public removeUploadButtons: NodeListOf<HTMLButtonElement> | undefined;

  public cachedFileInput: Node | undefined;

  public selectionButtons: NodeListOf<HTMLElement> | undefined;

  public createAccountCheckbox: HTMLInputElement | null | undefined;

  public createAccountFields: HTMLElement | null | undefined;

  public selectedProducts: Array<any> = [];

  public user: any;

  public wishlistContent: any;

  public inputCompany: HTMLInputElement | null | undefined;
  public buttonTabs: NodeListOf<HTMLButtonElement> | null | undefined;
  public tabColumn: HTMLElement | null | undefined;

  private formValidation: FormValidation;

  private apiBaseUrl: string | undefined;

  constructor(wishlistContent: any) {
    this.wishlistContent = wishlistContent;
  }

  async sendMail() {
    if (this.form) {
      const endpoint = this.form.action;
      const data = new FormData(this.form);

      this.selectedProducts.forEach((product: any, index) => {
        data.append(`product[${index}]`, JSON.stringify(product));
      });

      this.wishlistContent.forEach((list: any, i: number) => {
        let products = 0;

        const parsedList = JSON.stringify(
          {
            title: list.title,
            items: list.items
              .map((item: any) => {
                const foundProduct = this.selectedProducts.filter((product: any) => product.element_id == item.element_id && product.list_id == list.list_id);
                if (foundProduct.length) {
                  products += 1;
                  return foundProduct[0];
                }
              })
              .filter((item: any) => item != null),
            sections: list.sections.map((section: any) => {
              return {
                title: section.title,
                items: section.items
                  .map((item: any) => {
                    const foundProduct = this.selectedProducts.filter((product: any) => product.element_id == item.element_id && product.list_id == section.section_id);
                    if (foundProduct.length) {
                      products += 1;
                      return foundProduct[0];
                    }
                  })
                  .filter((item: any) => item != null),
              };
            }),
          }
        );

        if (products > 0) {
          data.append(`wishlistStructure[${i}]`, parsedList);
        }
      });

      await fetch(endpoint, {
        method: 'post',
        body: data,
      })
        .then((res) => res.json())
        .then(res => {
          if (res.success == true || res.success === 'true') {
            messageBoxSuccess({
              contentDe: 'E-Mail wurde erfolgreich gesendet.',
              contentEn: 'Successfully sent e-mail.',
            });

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ lead: null });
            window.dataLayer.push({
              event: 'generate_lead',
              lead: {
                type: 'form_configuration',
                email: data.get('email'),
                new_lead: res.hasOwnProperty('is_first_contact') && res.is_first_contact ? 'Yes' : 'No'
              }
            });

            this.form?.classList.add('success');
            this.popup?.querySelector('.m-popup__modal-modules')?.classList.add('hidden');
          } else {
            throw new Error(JSON.stringify(res.errors));
          }
        })
        .catch((error) => {
          console.error(error);

          messageBoxError({
            contentDe: 'Es ist ein Fehler aufgetreten. E-Mail konnte nicht gesendet werden.',
            contentEn: 'An error appeared. Could not send e-mail.',
          });
        });
    }
  }

  async createAccount(): Promise<any> {
    const data = new FormData();

    // @ts-ignore
    // @ts-ignore
    data.append(window.csrfTokenName, window.csrfTokenValue);
    data.append('action', 'users/save-user');

    let salutation = this.form?.querySelector('select[name="salutation"]');
    if (salutation instanceof HTMLSelectElement) {
      data.append('fields[salutation]', salutation.value);
      data.append('address[fields][addressTitle]', salutation.value);
    }

    let firstName = this.form?.querySelector('input[name="firstName"]');
    if (firstName instanceof HTMLInputElement) {
      data.append('firstName', firstName.value);
      data.append('fields[firstName]', firstName.value);
      data.append('address[firstName]', firstName.value);
    }

    let lastName = this.form?.querySelector('input[name="lastName"]');
    if (lastName instanceof HTMLInputElement) {
      data.append('lastName', lastName.value);
      data.append('fields[lastName]', lastName.value);
      data.append('address[lastName]', lastName.value);
    }

    let email = this.form?.querySelector('input[name="email"]');
    if (email instanceof HTMLInputElement) {
      data.append('email', email.value);
      data.append('fields[email]', email.value);
    }

    let phone = this.form?.querySelector('input[name="phoneNumber"]');
    if (phone instanceof HTMLInputElement) {
      data.append('fields[phone]', phone.value);
      data.append('address[fields][phoneNumber]', phone.value);
    }

    let organization = this.form?.querySelector('input[name="organization"]');
    let company = this.form?.querySelector('input[name="company"]');
    if (organization instanceof HTMLInputElement) {
      data.append('fields[companyName]', organization.value);
      data.append('address[organization]', organization.value);
    }
    else if (company instanceof HTMLInputElement) {
      data.append('fields[companyName]', company.value);
      data.append('address[organization]', company.value);
    }

    let postalCode = this.form?.querySelector('input[name="postalCode"]');
    if (postalCode instanceof HTMLInputElement) {
      data.append('address[postalCode]', postalCode.value);
    }

    let locality = this.form?.querySelector('input[name="locality"]');
    if (locality instanceof HTMLInputElement) {
      data.append('address[locality]', locality.value);
    }

    let street = this.form?.querySelector('input[name="street"]');
    if (street instanceof HTMLInputElement) {
      data.append('address[addressLine1]', street.value);
    }

    let notes = this.form?.querySelector('input[name="addressNotes"]');
    if (notes instanceof HTMLInputElement) {
      data.append('address[fields][addressNotes]', notes.value);
    }

    let country = this.form?.querySelector('select[name="country"]');
    if (country instanceof HTMLSelectElement) {
      data.append('address[countryCode]', country.value);
    }

    let password = this.form?.querySelector('input[name="password"]');
    if (password instanceof HTMLInputElement) {
      data.append('password', password.value);
    }

    let success = false;
    await fetch(this.apiBaseUrl!, {
      method: 'post',
      headers: {
        'Accept': 'application/json',
      },
      body: data,
    })
    .then(res => res.json())
    .then((res) => {
      if (res.id && res.id != "") {
        success = true;
        messageBoxSuccess({
          contentDe: 'Account erfolgreich angelegt. Bitte überprüfe dein E-Mail-Postfach.',
          contentEn: 'Account successfully created. Please check your email inbox.',
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'sign_up',
          user: {
            email: data.get('email')
          }
        });

        return res;
      } else {
        throw new Error(JSON.stringify(res.errors));
      }
    })
    .catch((error) => {
      let errorObj = JSON.parse(error.message);

      if (errorObj.email) {
        messageBoxError({
          contentDe: errorObj.email[0],
          contentEn: errorObj.email[0],
        });
      }
      else {
        messageBoxError({
          contentDe: 'Account konnte nicht angelegt werden',
          contentEn: 'Account could not be created',
        });
      }
    });
    return success;
  }

  async handlerFormSubmit() {
    const button = this.form?.querySelector('.js-submit-button') as HTMLButtonElement;

    button.disabled = true;
    button.classList.add('loading');

    if (this.user.email) {
      await this.sendMail();
      button.disabled = false;
      button.classList.remove('loading');
      return;
    }

    let createAccount = false;
    const createAccountCheckbox = this.form?.querySelector('input[name="create_account"]') as HTMLInputElement;

    if (createAccountCheckbox?.checked) {
      const password = this.form?.querySelector('input[name="password"]') as HTMLInputElement;
      const passwordRepeat = this.form?.querySelector('input[name="password-repeat"]') as HTMLInputElement;

      if (password.value === passwordRepeat.value && password.value !== '') {
        createAccount = true;
      } else {
        messageBoxError({
          contentDe: 'Es ist ein Fehler aufgetreten. Bitte überprüfe Deine Passwörter.',
          contentEn: 'An error appeared. Please check your passwords.',
        });

        password.classList.add('has-error');
        passwordRepeat.classList.add('has-error');
        password.addEventListener('keydown', () => password.classList.remove('has-error'));
        passwordRepeat.addEventListener('keydown', () => passwordRepeat.classList.remove('has-error'));

        button.disabled = false;
        button.classList.remove('loading');

        return;
      }
    }

    if (this.form?.reportValidity()) {
      let res = {
        success: true,
      };

      if (createAccount) {
        let accountCreated = await this.createAccount();
        if (accountCreated == false || accountCreated == null) {
          button.disabled = false;
          button.classList.remove('loading');
          return;
        }
      }

      if (res.success) {
        await this.sendMail();
        button.disabled = false;
        button.classList.remove('loading');
      }
    }
  }

  private handlerError() {
    const elError = this.form?.querySelector('.has-error');
    if (elError && this.popup) {
      const top = elError.getBoundingClientRect().top + this.popup.scrollTop - 50;
      this.popup.scrollTo({top});
      (elError as HTMLElement).focus();
    }
  }

  setFilename(e: Event) {
    const target = e.currentTarget as HTMLInputElement;

    if (target.files) {
      if (target.files[0].size > 5000000) {
        messageBoxError({
          contentDe: 'Die Datei ist leider zu groß (> 5MB).',
          contentEn: 'The file is too big (> 5MB).',
        });

        // @ts-ignore
        target.value = null;
      }

      if (target.files) {
        const fileTypes = [
          'image/apng',
          'image/jpeg',
          'image/pjpeg',
          'image/png',
          'image/tiff',
          'image/webp',
          'application/pdf',
        ];

        if (!fileTypes.includes(target.files[0].type)) {
          messageBoxError({
            contentDe: 'Ungültiger Dateityp (erlaubt: Bilder, PDF).',
            contentEn: 'Invalid filetype (allowed: images, pdf).',
          });

          // @ts-ignore
          target.value = null;
        }
      }
    }

    if (target.files && target.nextElementSibling) {
      target.nextElementSibling.innerHTML = target.files[0].name;
    }
  }

  addUpload() {
    const container: HTMLElement | null | undefined = this.form?.querySelector('.m-wishlist-popup-call-expert__file-upload-fields');
    const lastInput: HTMLElement | null | undefined = container?.querySelector('djx-grid-row:last-of-type input');

    if (this.cachedFileInput) {
      const clone = this.cachedFileInput.cloneNode(true);
      const input = (clone as HTMLElement).querySelector('input');
      if (input) {
        const newIndex = Number(lastInput?.dataset.index) || 0;
        input.name = `file-${newIndex + 1}`;
        input.dataset.index = `${newIndex + 1}`;
      }
      container?.appendChild(clone);
    }

    this.removeUploadButtons = this.form?.querySelectorAll('.m-wishlist-popup-call-expert__file-upload-remove-upload');
    this.removeUploadButtons?.forEach((button) => {
      button.addEventListener('click', this.removeUpload.bind(this));
      button.disabled = false;
    });
    this.uploadButtons = this.form?.querySelectorAll('.m-wishlist-popup-call-expert__file-upload input');
    this.uploadButtons?.forEach((input) => input.addEventListener('change', this.setFilename.bind(this)));
  }

  removeUpload(e: Event) {
    const target = e.currentTarget as HTMLElement;
    const elementToRemove = target.closest('djx-grid-row');

    elementToRemove?.parentElement?.removeChild(elementToRemove);

    this.removeUploadButtons = this.form?.querySelectorAll('.m-wishlist-popup-call-expert__file-upload-remove-upload');

    if (this.removeUploadButtons?.length === 1) {
      this.removeUploadButtons[0].disabled = true;
    }
  }

  handleSelection(e: Event) {
    const target = e.currentTarget as HTMLElement;

    switch (target.dataset.type) {
      case 'list':
        if (
          target.classList.contains('is-selected') &&
          target.closest('.o-wishlist-accordion__list')?.querySelectorAll('.o-wishlist-accordion__selection.is-selected').length ==
            target.closest('.o-wishlist-accordion__list')?.querySelectorAll('.o-wishlist-accordion__selection').length
        ) {
          const productsToRemove = target.closest('.o-wishlist-accordion__list')?.querySelectorAll('.o-wishlist-accordion__selection[data-type="product"]');
          productsToRemove?.forEach((element: any) => {
            this.selectedProducts = this.selectedProducts.filter((product: any) => product.wishlist_id != element.dataset.wishlistId);
          });

          target.classList.remove('is-selected');
          target
            .closest('.o-wishlist-accordion__list')
            ?.querySelectorAll('.o-wishlist-accordion__selection')
            ?.forEach((element) => element.classList.remove('is-selected'));
        } else {
          const productsToAdd = target.closest('.o-wishlist-accordion__list')?.querySelectorAll('.o-wishlist-accordion__selection:not(.is-selected)[data-type="product"]');
          productsToAdd?.forEach((element: any) => {
            this.selectedProducts.push({
              name: element.dataset.name,
              url: element.dataset.url,
              image_url: element.dataset.imageUrl,
              description: element.dataset.description,
              web_teaser: element.dataset.webTeaser,
              element_quantity: element.dataset.elementQuantity,
              element_type: element.dataset.elementType,
              element_id: element.dataset.elementId,
              wishlist_id: element.dataset.wishlistId,
              list_id: element.dataset?.sectionId ? element.dataset?.sectionId : element.dataset.listId,
              with_accessories: element.dataset?.withAccessories && element.dataset?.withAccessories !== '' ? element.dataset?.withAccessories : null,
            });
          });

          target.classList.add('is-selected');
          target
            .closest('.o-wishlist-accordion__list')
            ?.querySelectorAll('.o-wishlist-accordion__selection')
            ?.forEach((element) => element.classList.add('is-selected'));
        }
        break;
      case 'section':
        if (
          target.classList.contains('is-selected') &&
          target.closest('.o-wishlist-accordion__group')?.querySelectorAll('.o-wishlist-accordion__selection.is-selected').length ==
            target.closest('.o-wishlist-accordion__group')?.querySelectorAll('.o-wishlist-accordion__selection').length
        ) {
          const productsToRemove = target.closest('.o-wishlist-accordion__group')?.querySelectorAll('.o-wishlist-accordion__selection[data-type="product"]');
          productsToRemove?.forEach((element: any) => {
            this.selectedProducts = this.selectedProducts.filter((product: any) => product.wishlist_id != element.dataset.wishlistId);
          });

          target.classList.remove('is-selected');
          target
            .closest('.o-wishlist-accordion__group')
            ?.querySelectorAll('.o-wishlist-accordion__selection')
            ?.forEach((element) => element.classList.remove('is-selected'));
          if (target.closest('.o-wishlist-accordion__list')?.querySelectorAll('.o-wishlist-accordion__selection.is-selected').length == 1) {
            target.closest('.o-wishlist-accordion__list')?.querySelector('.o-wishlist-accordion__selection')?.classList.remove('is-selected');
          }
        } else {
          const productsToAdd = target.closest('.o-wishlist-accordion__group')?.querySelectorAll('.o-wishlist-accordion__selection:not(.is-selected)[data-type="product"]');
          productsToAdd?.forEach((element: any) => {
            this.selectedProducts.push({
              name: element.dataset.name,
              url: element.dataset.url,
              image_url: element.dataset.imageUrl,
              description: element.dataset.description,
              web_teaser: element.dataset.webTeaser,
              element_type: element.dataset.elementType,
              element_quantity: element.dataset.elementQuantity,
              element_id: element.dataset.elementId,
              wishlist_id: element.dataset.wishlistId,
              list_id: element.dataset?.sectionId ? element.dataset?.sectionId : element.dataset.listId,
              with_accessories: element.dataset?.withAccessories && element.dataset?.withAccessories !== '' ? element.dataset?.withAccessories : null,
            });
          });

          target.classList.add('is-selected');
          target
            .closest('.o-wishlist-accordion__group')
            ?.querySelectorAll('.o-wishlist-accordion__selection')
            ?.forEach((element) => element.classList.add('is-selected'));
          target.closest('.o-wishlist-accordion__list')?.querySelector('.o-wishlist-accordion__selection')?.classList.add('is-selected');
        }
        break;
      case 'product':
        if (target.classList.contains('is-selected')) {
          this.selectedProducts = this.selectedProducts.filter((product: any) => product.wishlist_id != target.dataset.wishlistId);

          target.classList.remove('is-selected');
          if (target.closest('.o-wishlist-accordion__group')?.querySelectorAll('.o-wishlist-accordion__selection.is-selected').length == 1) {
            target.closest('.o-wishlist-accordion__group')?.querySelector('.o-wishlist-accordion__selection')?.classList.remove('is-selected');
          }
          if (target.closest('.o-wishlist-accordion__list')?.querySelectorAll('.o-wishlist-accordion__selection.is-selected').length == 1) {
            target.closest('.o-wishlist-accordion__list')?.querySelector('.o-wishlist-accordion__selection')?.classList.remove('is-selected');
          }
        } else {
          this.selectedProducts.push({
            name: target.dataset.name,
            url: target.dataset.url,
            image_url: target.dataset.imageUrl,
            description: target.dataset.description,
            web_teaser: target.dataset.webTeaser,
            element_type: target.dataset.elementType,
            element_quantity: target.dataset.elementQuantity,
            element_id: target.dataset.elementId,
            wishlist_id: target.dataset.wishlistId,
            list_id: target.dataset?.sectionId ? target.dataset?.sectionId : target.dataset.listId,
            with_accessories: target.dataset?.withAccessories && target.dataset?.withAccessories !== '' ? target.dataset?.withAccessories : null,
          });

          target.classList.add('is-selected');
          target.closest('.o-wishlist-accordion__group')?.querySelector('.o-wishlist-accordion__selection')?.classList.add('is-selected');
          target.closest('.o-wishlist-accordion__list')?.querySelector('.o-wishlist-accordion__selection')?.classList.add('is-selected');
        }
        break;
      default:
    }
  }

  toggleCreateAccount() {
    this.createAccountFields?.classList.toggle('d-none');
  }

  private toggleInputCompany(e: MouseEvent, isActive: boolean) {
    const { buttonTabs, tabColumn, inputCompany } = this;
    const tabColumnNeighbor = tabColumn ? tabColumn.nextElementSibling : null;
    // console.log('toggle', buttonTabs, tabColumn, inputCompany);
    if(buttonTabs && tabColumnNeighbor && tabColumn && inputCompany) {
      buttonTabs.forEach( (buttonTab) => buttonTab.classList.remove('is--active'));
      (e.target as HTMLElement).classList.add('is--active');

      inputCompany.value = '';
      if (isActive) {
        inputCompany.setAttribute('required', '');
        tabColumn.classList.remove('hidden');
        tabColumnNeighbor?.classList.add('col-md-offset-2');
      } else {
        inputCompany.removeAttribute('required');
        tabColumn.classList.add('hidden');
        tabColumnNeighbor?.classList.remove('col-md-offset-2');
      }
    }
  }

  selectAll() {
    const buttons = this.popup?.querySelectorAll('.o-wishlist-accordion__selection[data-type="product"]') as NodeListOf<HTMLButtonElement>;

    buttons?.forEach((button) => {
      this.selectedProducts.push({
        name: button.dataset.name,
        url: button.dataset.url,
        image_url: button.dataset.imageUrl,
        description: button.dataset.description,
        web_teaser: button.dataset.webTeaser,
        element_type: button.dataset.elementType,
        element_quantity: button.dataset.elementQuantity,
        element_id: button.dataset.elementId,
        wishlist_id: button.dataset.wishlistId,
        list_id: button.dataset?.sectionId ? button.dataset?.sectionId : button.dataset.listId,
        with_accessories: button.dataset?.withAccessories && button.dataset?.withAccessories !== '' ? button.dataset?.withAccessories : null,
      });
    });
  }

  bindings() {
    if (this.form) {
      this.formValidation = new FormValidation(
        this.form,
        this.handlerFormSubmit.bind(this),
        this.handlerError.bind(this)
      );
      this.formValidation.init();
    }

    if (this.uploadButtons) {
      this.uploadButtons.forEach((input) => input.addEventListener('change', this.setFilename.bind(this)));
    }

    if (this.addUploadButton) {
      this.addUploadButton.addEventListener('click', this.addUpload.bind(this));
    }

    if (this.removeUploadButtons) {
      this.removeUploadButtons.forEach((button) => button.addEventListener('click', this.removeUpload.bind(this)));
    }

    if (this.selectionButtons) {
      this.selectionButtons.forEach((button) => {
        button.classList.add('is-selected');
        button.addEventListener('click', this.handleSelection.bind(this));
      });

      this.selectAll();
    }

    if (this.createAccountCheckbox) {
      this.createAccountCheckbox.addEventListener('change', this.toggleCreateAccount.bind(this));
    }

    if(this.buttonTabs) {
      this.buttonTabs[0].addEventListener('click', (e) => this.toggleInputCompany(e, false));
      this.buttonTabs[1].addEventListener('click', (e) => this.toggleInputCompany(e, true));
    }
  }

  cache() {
    this.popup = document.getElementById('wishlist-popup-call-expert');
    this.form = this.popup?.querySelector('form') || null;
    this.uploadButtons = this.form?.querySelectorAll('.m-wishlist-popup-call-expert__file-upload input');
    this.addUploadButton = this.form?.querySelector('.m-wishlist-popup-call-expert__file-upload-add-upload') || null;
    this.removeUploadButtons = this.form?.querySelectorAll('.m-wishlist-popup-call-expert__file-upload-remove-upload');
    this.cachedFileInput = this.form?.querySelector('.m-wishlist-popup-call-expert__file-upload-fields djx-grid-row')?.cloneNode(true);
    this.selectionButtons = this.popup?.querySelectorAll('.o-wishlist-accordion__selection');
    this.createAccountCheckbox = this.form?.querySelector('input[name="create_account"]');
    this.createAccountFields = this.form?.querySelector('.js-wishlist-popup-password-container');
    this.user = JSON.parse(this.popup?.querySelector('.js-current-user')?.innerHTML || '{}');
    this.buttonTabs = this.popup?.querySelectorAll('.js-form-tab-switch');
    this.tabColumn = this.popup?.querySelector('[data-key="company"]');
    this.inputCompany = this.form?.querySelector('input[name="company"]');
    this.apiBaseUrl = document.body.dataset.apiBaseUrl;
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default PopupExpert;
